import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class GetNewsUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (): Promise<any> => {
        return await this._aiRepository.getNews();
    }
}

export const GetNewsUseCaseName = "GetNewsUseCaseName";
